export default "__VITE_ASSET__DVP59U2d__"